module.exports = __webpack_public_path__ + "img/exam_jan_2025_koy154fg.b1ab118f.jpg";